import * as types from '../constants/actionTypes';
import objectAssign from 'object-assign';

const initialState = {
	userData: {},
	forgotData: {},
	resetData: {},
	activateData: {},
	signinFail: {}
};

export default function signinReducer(state = [], action) {
	switch (action.type) {
		// case types.SIGN_IN_USER:
		// 	return [...state,
		// 	Object.assign({}, action.signin)
		// 	];
		case types.SIGN_IN_USER:
			return objectAssign({}, state, {
				signin: action.signin
			});
		case types.SIGN_UP_USER:
			return objectAssign({}, state, {
				userData: action.userData
			});
		case types.FORGOT_PASSWORD:
			return objectAssign({}, state, {
				forgotData: action.data
			});
		case types.RESET_PASSWORD:
			return objectAssign({}, state, {
				resetData: action.data
			});
		case types.ACTIVATE_ACCOUNT:
			return objectAssign({}, state, {
				activateData: action.data
			});
		case types.UNLOCK_ACCOUNT:
			return objectAssign({}, state, {
				unLockData: action.data
			});
		case types.UNSUBSCRIBE_EMAILS:
			return objectAssign({}, state, {
				unSubscribe: action.data
			});
		case types.OTP_VERIFICATION:
			return objectAssign({}, state, {
				otpVerified: action.data
			});
		case types.GET_SPECIALIST_FOR_IMAGES:
			return objectAssign({}, state, {
				specialistData: action.data
			});
		case types.GET_APPROVED_SPECIALIST_FOR_IMAGES:
			return objectAssign({}, state, {
				ApprovedspecialistData: action.data
			});
		case types.GET_BLOGS_FOR_IMAGES:
			return objectAssign({}, state, {
				BlogsData: action.data
			});
		case types.GET_APPROVED_BLOGS_FOR_IMAGES:
			return objectAssign({}, state, {
				ApprovedBlogsData: action.data
			});
		case types.UPDATE_PROFILE_IMAGE_VERIFIED:
			return objectAssign({}, state, {
				updateImageData: action.data
			});
		case types.UPDATE_BLOGS_IMAGE_VERIFIED:
			return objectAssign({}, state, {
				updateBlogsData: action.data
			});

		case types.ADMIN_SIGNIN_FAIL:
			return objectAssign({}, state, {
				signinFail: action.data
			});
		case types.RESEND_OTP:
			return objectAssign({}, state, {
				resendOTP: action.resendOTP
			});
		default:
			return state;
	}
}